import React, { useEffect, useState } from "react";
import {
    TableContainer,
    Paper,
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Button,
} from "@mui/material";
import MDBox from "components/MDBox";

import { keyframes } from "@mui/system";
import MDTypography from "components/MDTypography";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

import Pagination from "@mui/material/Pagination";
import {
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import axios from "api/baseurl";
import { toast } from "react-toastify";
// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
function ViewAllPatientDetails() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
  const token = loginData?.token;
const [openPopup, setOpenPopup] = useState(false);
const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [patients, setPatients] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
      const [searchTerm, setSearchTerm] = useState("");

const navigate = useNavigate();
  // ------------------ FETCH ------------------ //
  const fetchPatients = async () => {
          const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    try {
      const res = await axios.get(`/api/doctorregistration/alerts/view-all/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
   if (res.status === 200) {

      const decryptedData = decryptBody(res.data, secretKey);

      // NO SORT — direct response
      setPatients(decryptedData.content || []);

      setCurrentPage(decryptedData.number + 1);

      setTotalPages(decryptedData.totalPages);
    }

  } catch (error) {

    console.error("Error fetching patients:", error);

    // toast.error("Failed to fetch patients");

  } finally {

    setLoading(false);
  }
};

  const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };
 useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchPatients(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody({ searchTerm: searchTerm }, secretKey);
   
       const response = await axios.post(`/api/patientregistration/search-all`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },  
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
            setPatients(decryptedData.content || []);

        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching :", error);
    } finally {
      setLoading(false);
    }
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

const handleAcceptAlert = async () => {
  try {
    await axios.post(
      `/api/dutydoctor/alerts/action`,
      { notificationId: selectedNotificationId ,action: "ACCEPT", },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    toast.success("Alert Accepted");
    setOpenPopup(false);   // ✅ close popup
    fetchPatients();       // ✅ refresh list
  } catch {
    toast.error("Failed to accept alert");
  }
};
const handleAcceptClick = (id) => {
  setSelectedNotificationId(id);
  setOpenPopup(true);
};
const handleSnooze = async () => {
  try {
    await axios.post(
      `/api/dutydoctor/alerts/action`,
      { notificationId: selectedNotificationId , action: "SNOOZE",},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    toast.success("Notification snoozed");
    setOpenPopup(false);
    fetchPatients(); // refresh list
  } catch {
    toast.error("Failed to snooze");
  }
};
  // ------------------ INIT ------------------ //
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await fetchPatients();
      setLoading(false);
    };
    init();
  }, []);

  // ------------------ LOADER ------------------ //
 
  const headerStyle = {
  color: "#fff",
  fontWeight: 600,
  fontSize: "14px",
  borderRight: "1px solid rgba(255,255,255,0.3)",
};

  // ------------------ UI ------------------ //
  return (
    <DashboardLayout>
      <DashboardNavbar />
  <MedicalAbstractBackground/>
   {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                        backgroundColor: "#1A237E", 
                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
      <Box p={3}>
         <Box mb={2}>
   <Button
  variant="outlined"
  onClick={() => navigate(-1)}
  sx={{
    textTransform: "none",
    borderRadius: 2,
    fontSize: "13px",
    px: 2,
    color: "#4882e0", // dark grey text
    borderColor: "#3f6cb0", // soft border
    "&:hover": {
      backgroundColor: "#dfe5eb",
      borderColor: "#d3d7df",
    },
  }}
>
  ← Back
</Button>
  </Box>
        <Card sx={{ borderRadius: 3, boxShadow: 4 }}>
          <CardContent sx={{ p: 2 }}>

            {/* HEADER */}
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <LocalHospitalIcon color="primary" />
      <MDTypography variant="h5" sx={{ flex: 1 }}>
                Patient Alerts
               </MDTypography>
            </Box>
{/* <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
          <MDInput
        placeholder="Search Name or Contact"
        variant="outlined"
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          maxWidth: "400px",
          backgroundColor: "#fff",
          borderRadius: "8px",
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton size="small">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
        </MDBox> */}
            {/* TABLE */}
            <Box sx={{ maxHeight: "70vh" }}>
              <Table
                sx={{
      border: "1px solid #dcdcdc",
      minWidth: 1000, // ⬅️ increased overall width
      tableLayout: "fixed", // ⬅️ important for width control
    }}
              >

                {/* HEADER */}
                 <TableHead>
      <TableRow sx={{ backgroundColor: "#1A237E" }}>
        <TableCell sx={{ ...headerStyle, width: 200 }}>Patient Name</TableCell>
        <TableCell sx={{ ...headerStyle, width: 200 }}>Age / Gender</TableCell>
        <TableCell sx={{ ...headerStyle, width: 200 }}>Type</TableCell>
        <TableCell sx={{ ...headerStyle, width: 300 }}>Message</TableCell>
        <TableCell sx={{ ...headerStyle, width: 150 }} align="center">
          Action
        </TableCell>
      </TableRow>
                

                {/* BODY */}
                <TableBody>
                  {patients?.map((p) => (
                    <TableRow
                      key={p.notificationId}
                      hover
                      sx={{
                        "& td": {
                          borderBottom: "1px solid #e0e0e0",
                          borderRight: "1px solid #e0e0e0",
                          fontSize: "14px",
                          py: 1.5,
                        },
                      }}
                    >
                      {/* NAME */}
                      <TableCell sx={{ width: "20%" }}>{p.patientName}</TableCell>

                      {/* AGE */}
                      <TableCell sx={{ width: "20%" }}>
                        {p.age} / {p.gender}
                      </TableCell>

                      {/* TYPE */}
                      <TableCell sx={{ width: "20%" }}>
                        <Chip
                          label={p.type}
                          size="small"
                          color="info"
                          sx={{ fontSize: "12px" }}
                        />
                      </TableCell>

                      {/* MESSAGE */}
                      <TableCell sx={{ width: "30%" }}>
                        <Typography sx={{ fontSize: "14px" }} noWrap>
                          {p.message}
                        </Typography>
                      </TableCell>

                      {/* ACTION */}
                      <TableCell sx={{ width: "20%" }} align="center">
                       <Button
  variant="contained"
  onClick={() => {
    setSelectedNotificationId(p.notificationId);
    setOpenPopup(true);
  }}
  sx={{
    backgroundColor: "#A5D6A7",
    color: "#f7ecec",
    textTransform: "none",
    fontSize: "13px",
    borderRadius: 2,
  }}
>
  Accept/Snooze
</Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                </TableHead>
                <Box mt={2} display="flex" justifyContent="center">
                          <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="success"
                             sx={{
                    "& .MuiPaginationItem-root": {
                      borderRadius: "4px",
                      color: "#1A237E",          // Text color
                      borderColor: "#1A237E",    // Border color if outlined
                    },
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#1A237E", // Selected background
                      color: "#fff",                 // Selected text color
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "#1A237E", // Slight hover effect
                    },
                  }}
                          />
                        </Box>
              </Table>
            </Box>

            {/* EMPTY */}
            {patients.length === 0 && (
              <Typography textAlign="center" mt={3} color="text.secondary">
                No patient alerts available
              </Typography>
            )}

          </CardContent>
        </Card>
      </Box>
      <Dialog
  open={openPopup}
  onClose={() => setOpenPopup(false)}
  PaperProps={{
    sx: {
      borderRadius: 4,
      width: 340,
      p: 2,
      position: "relative",
    },
  }}
>
  {/* ❌ Cancel Icon */}
  <IconButton
    onClick={() => setOpenPopup(false)}
    sx={{
      position: "absolute",
      top: 8,
      right: 8,
      color: "#777",
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>

  {/* CONTENT */}
  <DialogContent sx={{ textAlign: "center", py: 2 }}>
    <Typography
     sx={{
        fontSize: "15px",
        fontWeight: 600,
        color: "#1A237E",
        mb: 1,
      }}
    >
      Patient Alert
    </Typography>

    <Typography sx={{ fontSize: "13px", color: "#555" }}>
      "Accept this alert or snooze it to be notified again in 5 minutes."
    </Typography>
  </DialogContent>

  {/* ACTION BUTTONS */}
  <DialogActions
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      px: 2,
      pb: 2,
    }}
  >
    {/* 🔵 ACCEPT */}
    <Button
      onClick={handleAcceptAlert}
      variant="contained"
      fullWidth
      sx={{
        backgroundColor: "#1A237E",
        textTransform: "none",
        fontSize: "13px",
        borderRadius: 3,
        py: 1,
        "&:hover": {
          backgroundColor: "#0D1B5E",
        },
      }}
    >
      Accept
    </Button>

    {/* 🟡 SNOOZE */}
    <Button
      onClick={handleSnooze}
      variant="outlined"
      fullWidth
      sx={{
        textTransform: "none",
        fontSize: "13px",
        borderRadius: 3,
        borderColor: "#f4b400",
        color: "#f4b400",
        "&:hover": {
          backgroundColor: "#fff8e1",
          borderColor: "#f4b400",
        },
      }}
    >
      Snooze
    </Button>
  </DialogActions>
</Dialog>
    </DashboardLayout>
  );
}

export default ViewAllPatientDetails;